import getDashboardComponent from '@/app/pages/dashboard/utils'

import styles from './index.module.scss'

const HeaderSection = ({ data }) => {
  const { title, subtitle, components } = data || {}
  return (
    <div className={`${styles.headerSection} ew-p-16 ew-d-flex ew-gap-16 ew-flex-column`}>
      <div>
        <div className='ew-typography-large ew-color-inverse-primary'>{title}</div>
        <div className='ew-typography-small ew-fw-regular ew-color-tertiary'>{subtitle}</div>
      </div>
      {components?.items?.map(component => getDashboardComponent(component))}
    </div>
  )
}

export default HeaderSection
